import { render, staticRenderFns } from "./SignupDocuments.vue?vue&type=template&id=7f388dc5&"
import script from "./SignupDocuments.vue?vue&type=script&lang=js&"
export * from "./SignupDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports